function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required build-time env var ${name}. ` +
        `Vite bakes VITE_* vars into the bundle at build time — set this in the ` +
        `consumer's release workflow (build-args) or local .env before building.`,
    );
  }
  return value;
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5302/v1',
  auth0Domain: required('VITE_AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN),
  auth0ClientId: required('VITE_AUTH0_CLIENT_ID_MERCHANT', import.meta.env.VITE_AUTH0_CLIENT_ID_MERCHANT),
  auth0Audience: required('VITE_AUTH0_AUDIENCE', import.meta.env.VITE_AUTH0_AUDIENCE),
};
